import { Application } from '@hotwired/stimulus'

const application = Application.start()
window.Stimulus = application

// IMPORT CONTROLLERS MANUALLY
//import PageController from './page_controller.js'
import TurnstileController from './turnstile_controller.js'

// REGISTER CONTROLLERS
//application.register('page', PageController)
application.register('turnstile', TurnstileController)
